import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, Observable, of, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  constructor(private afAuth: AngularFirestore) {}
  getEmployeeData(): Observable<any> {
    return this.afAuth
      .collection('employeeProfile')
      .snapshotChanges()
      .pipe(
        take(1),
        map(
          (data: any) => {
            return data.map((e: any) => {
              const obj: any = e.payload.doc.data();
              obj['docId'] = e.payload.doc.id;
              obj['name'] = obj?.firstName + ' ' + obj?.lastName;
              return obj;
            });
          },
          (error: any) => {
            console.log(error);
            return of(null);
          }
        )
      );
  }
}
